import gql from "graphql-tag";
const asiaAltQueries = {}
const clients = {}
clients.get = gql(` 
query GetClient($id: Number!, $name: String!) {
  getClient(id: $id, name: $name) {
    id
    name
    description
    effectivedate
    status
    createdate
    modifydate
    orgs_id
  } 
}   
`)
clients.list = gql(` 
query getAllClients {
    listClients{
        items{
                name
                description
                effectivedate
                status
        }
    }
}
`)
asiaAltQueries.clients = clients;
const commitment = {}
commitment.list = gql(`                                                                                                 query getAllCommitments {
    listCommitments{
            items{
FundName
Line_Number
Commitment_Date
Y2006
Y2007
Y2008
Y2009
Y2010
Y2011
Y2012
Y2013
Y2014
Y2015
Y2016
Y2017
AACP_I_Commitment
Fund_I_Side_Car_Commitment
AACP_II_Commitment
Fund_II_Side_Car_Commitment
Ivory_Commitment
NJAI_Commitment
CAI_Commitments_Balanced
CAI_Commitments_Co_Investment
Fei__Commitment
AACP_III_Commitment
Fund_III_Side_Car_Commitment
NJAI_II_Commitment_Tranche_I
NJAI_II_Commitment_Tranche_II
Ivory_II_Commitment_Balanced
Ivory_II_Commitment_Co_Investment
MDAI_I_Commitment_Balanced
MDAI_I_Commitment_Co_Investment
NY_Balanced_Commitment
NY_Co_Invst_Commitment
Focus_Commitment
Fei_II_Commitment
AACP_IV_Commitment
Fund_IV_Side_Car_Commitment
AACP_IV_Ex_Japan_Commitment
China_Only_Commitments
FL_Investors_Commitments_Balanced
FL_Investors_Commitments_Co_Investment
MDAI_II_Commitments_Balanced
MDAI_II_Commitments_Co_Investment
VA_Investors_Commitments_Balanced
VA_Investors_Commitments_Co_Investment
IL_Investors_Commitments_Balanced01
IL_Investors_Commitments_Balanced02
IL_Investors_Commitments_Co_Investment
NY_II_Balanced_Commitment
NY_II_Co_Invst_Commitment
Focus_2014_Commitment
Ivory_III_Commitments_Balanced_AB
Ivory_III_Commitments_Balanced_C
Ivory_III_Commitments_o_Investment
NJAI_III_Commitments_Balanced
NJAI_III_Commitments_Co_Investment
Fei_III
Hessen_Dr_Commitments_Balanced_I
Hessen_Dr_Commitments_Balanced_II
Hessen_Dr_Commitments_Co_Investment
Arcadia_Asia_Investors_LP_Commitments_Balanced
Arcadia_Asia_Investors_LP_Commitments_Co_Investment
AACP_V_Commitment
AACP_V_ERISA_Commitment
AACP_V_Side_Car_Commitment
FL_Investors_II_Commitments_Balanced
FL_Investors_II_Commitments_Co_Investment
MDAI_III_Commitments_Balanced
MDAI_III_Commitments_Co_Investment
VA_Investors_II_Commitments_Balanced
VA_Investors_II_Commitments_Co_Investment
NY_III_Balanced_Commitment
NY_III_Co_Invst_Commitment
FL_Investors_III_Commitments_Balanced
FL_Investors_III_Commitments_Co_Investment
Ivory_IV_Commitments_Balanced_A
Ivory_IV_Commitments_Balanced_B
Ivory_IV_Commitments_Co_Investment
MDAI_IV_Commitments_Balanced
MDAI_IV_Commitments_Co_Investment
VA_Investors_III_Commitments_Balanced
VA_Investors_III_Commitments_Co_Investment
MN_Asia_Investors_Commitments_Balanced
MN_Asia_Investors_Commitments_Co_Investment
AACP_VI_Commitment
AACP_VI_ERISA_Commitment
AACP_VI_Europe_Commitment
Fund_VI_Side_Cars
Penn_Asia_Commitment
SBS_Asia_I_Commitment
NG_Asia_Commitment
NM_Asia_Commitment
SF_Asia_Commitment
Fei_Co_Investment
MassMutual_Co_Investment
Calculated_Commitment
Discrepancy
Total__Commitment
Geography
Sub_Asset_Class
Defined_Manager_Type
Defined_Strategy
Fund_Size
Fund_Size_Category
Vintage_Year
Advisory_Board
Who_AB
Deal_Sourcer
Team_Lead
Current_Team
Oversubscribed
Co_investment_Offered
Investment_Period_End_Date
China
Japan
Korea
India
Pan_Asia
Australia
Indonesia
Primary
Secondary
Direct_Co_Investment
Structured_Primary
Y2005_Earlier
                    }
                    }
                    }
`)
asiaAltQueries.commitment = commitment;
const entitydbs = {}
entitydbs.get = gql(` 
query GetExcavation($DealID: Number!) {
  getClient(DealID: $DealID) {
      DealID
      CommonName
      DealLimit
      ARFundTermText
      AsiaAltDiscount
      Asia_Alt_GP_Legal_Entity
      Asia_Alt_GP_Legal_Entity_Commitment
      CarryRate
      ClawBackDate
      ClawBackIndemnity
      ClawBackTiming
      CommitDate
      DealCurrency
      DealLimitComps
      DebtLimit
      DebtLimitTerms
      Description
      FXRate
      FeeStepDownDate
      FinRepAnnual
      FinRepQuarter
      FinRepTax
      FinalCloseDate
      FiscalEndDate
      GPCommitGF
      GPCommitLE
      GPEntity
      GroupFundSize
      HurdleRate
      InitialCloseDate
      InvDescription
      InvEndDate
      InvType
      LEDomicile
      LEFundSize
      LEStructure
      LETermDate
      LETermDescription
      LPCommitGF
      LPCommitLE
      LegalEntity
      LiquidDate
      LiquidNotes
      MFeeDiscount
      MFeeInitialBase
      MFeeInitialRate
      MFeeStepDownBase
      MFeeStepDownRate
      MFeeStepDownTime
      MFeeTerms
      Manager
      OtherLimits
      SOIGrouping
      VintageYear
      WaterFallTerms
      WaterFallType
  } 
}   
`)
entitydbs.list = gql(` 
query getAllExcavations {
    listExcavations{
        items{
      DealID
      DealLimit
      CommonName
      ARFundTermText
      AsiaAltDiscount
      Asia_Alt_GP_Legal_Entity
      Asia_Alt_GP_Legal_Entity_Commitment
      CarryRate
      ClawBackDate
      ClawBackIndemnity
      ClawBackTiming
      CommitDate
      DealCurrency
      DealLimitComps
      DebtLimit
      DebtLimitTerms
      Description
      FXRate
      FeeStepDownDate
      FinRepAnnual
      FinRepQuarter
      FinRepTax
      FinalCloseDate
      FiscalEndDate
      GPCommitGF
      GPCommitLE
      GPEntity
      GroupFundSize
      HurdleRate
      InitialCloseDate
      InvDescription
      InvEndDate
      InvType
      LEDomicile
      LEFundSize
      LEStructure
      LETermDate
      LETermDescription
      LPCommitGF
      LPCommitLE
      LegalEntity
      LiquidDate
      LiquidNotes
      MFeeDiscount
      MFeeInitialBase
      MFeeInitialRate
      MFeeStepDownBase
      MFeeStepDownRate
      MFeeStepDownTime
      MFeeTerms
      Manager
      OtherLimits
      SOIGrouping
      VintageYear
      WaterFallTerms
      WaterFallType
        }
    }
}
`)
asiaAltQueries.entitydb = entitydbs;
const excavations = {}
excavations.get = gql(` 
query GetExcavation($DealID: Number!) {
  getClient(DealID: $DealID) {
      DealID
      CommonName
      DealLimit
      ARFundTermText
      AsiaAltDiscount
      Asia_Alt_GP_Legal_Entity
      Asia_Alt_GP_Legal_Entity_Commitment
      CarryRate
      ClawBackDate
      ClawBackIndemnity
      ClawBackTiming
      CommitDate
      DealCurrency
      DealLimitComps
      DebtLimit
      DebtLimitTerms
      Description
      FXRate
      FeeStepDownDate
      FinRepAnnual
      FinRepQuarter
      FinRepTax
      FinalCloseDate
      FiscalEndDate
      GPCommitGF
      GPCommitLE
      GPEntity
      GroupFundSize
      HurdleRate
      InitialCloseDate
      InvDescription
      InvEndDate
      InvType
      LEDomicile
      LEFundSize
      LEStructure
      LETermDate
      LETermDescription
      LPCommitGF
      LPCommitLE
      LegalEntity
      LiquidDate
      LiquidNotes
      MFeeDiscount
      MFeeInitialBase
      MFeeInitialRate
      MFeeStepDownBase
      MFeeStepDownRate
      MFeeStepDownTime
      MFeeTerms
      Manager
      OtherLimits
      SOIGrouping
      VintageYear
      WaterFallTerms
      WaterFallType
  } 
}   
`)
excavations.list = gql(` 
query getAllExcavations {
    listExcavations{
        items{
      DealID
      DealLimit
      CommonName
      ARFundTermText
      AsiaAltDiscount
      Asia_Alt_GP_Legal_Entity
      Asia_Alt_GP_Legal_Entity_Commitment
      CarryRate
      ClawBackDate
      ClawBackIndemnity
      ClawBackTiming
      CommitDate
      DealCurrency
      DealLimitComps
      DebtLimit
      DebtLimitTerms
      Description
      FXRate
      FeeStepDownDate
      FinRepAnnual
      FinRepQuarter
      FinRepTax
      FinalCloseDate
      FiscalEndDate
      GPCommitGF
      GPCommitLE
      GPEntity
      GroupFundSize
      HurdleRate
      InitialCloseDate
      InvDescription
      InvEndDate
      InvType
      LEDomicile
      LEFundSize
      LEStructure
      LETermDate
      LETermDescription
      LPCommitGF
      LPCommitLE
      LegalEntity
      LiquidDate
      LiquidNotes
      MFeeDiscount
      MFeeInitialBase
      MFeeInitialRate
      MFeeStepDownBase
      MFeeStepDownRate
      MFeeStepDownTime
      MFeeTerms
      Manager
      OtherLimits
      SOIGrouping
      VintageYear
      WaterFallTerms
      WaterFallType
        }
    }
}
`)
asiaAltQueries.excavation = excavations;

const business = {}
business.get = gql(` 
query GetBusiness($id: Number!, $name: String!) {
  getBusiness(id: $id, name: $name) {
    id
    name
    description
    status
    createdate
    modifydate
    orgs_id
  } 
}   
`)
business.list = gql(` 
query getAllBusiness {
    listBusinesses{
        items{
                name
                description
                status
        }
    }
}
`)
asiaAltQueries.business = business;


const policies = {}
policies.get = gql(` 
query GetPolicies($id: Number!, $name: String!) {
  getPolicies(id: $id, name: $name) {
    id
    name
    description
    link
    type
    status
    createdate
    modifydate
    orgs_id
  } 
}   
`)
policies.list = gql(` 
query getAllPolicies {
    listPolicies{
        items{
                id
                name
                description
                link
                type
                status
                createdate
                modifydate
                orgs_id
        }
    }
}
`)
asiaAltQueries.policies = policies;


const procedures = {}
procedures.get = gql(` 
query GetProcedures($id: Number!, $number: String!) {
  getProcedures(id: $id, number: $number) {
    id
    number
    description
    category
    type
    status
    createdate
    modifydate
  } 
}   
`)
procedures.list = gql(` 
query getAllProcedures {
    listProcedures{
        items{
                number
                description
                category
                type
                status
        }
    }
}
`)
asiaAltQueries.procedures = procedures;


const programs = {}
programs.get = gql(` 
query GetPrograms($id: Number!, $name: String!) {
  getPrograms(id: $id, name: $name) {
    id
    name
    shortname
    description
    sourcing
    effectivedate
    status
    createdate
    modifydate
    orgs_id
  } 
}   
`)
programs.list = gql(` 
query getAllPrograms {
    listPrograms{
        items{
                name
                shortname
                description
                sourcing
                effectivedate
                status
        }
    }
}
`)
asiaAltQueries.programs = programs;


const instructions = {}
instructions.get = gql(` 
query GetInstructions($id: Number!) {
  getInstructions(id: $id) {
    id
    description
    stage
    status
    createdate
    modifydate
    orgs_id
  } 
}   
`)
instructions.list = gql(` 
query getAllInstructions {
    listInstructions{
        items{
                description
                stage
                status
        }
    }
}
`)
asiaAltQueries.instructions = instructions;


const groups = {}
groups.get = gql(` 
query GetGroups($id: Number!, $number: String!) {
  getGroups(id: $id, number: $number) {
    id
    number
    effectivedate
    status
    createdate
    modifydate
    orgs_id
    businesslist_id
    clientslist_id
  } 
}   
`)
groups.list = gql(` 
query getAllGroups {
    listGroups{
        items{
                number
                effectivedate
                status
                businesslist_id
                clientslist_id
        }
    }
}
`)
asiaAltQueries.groups = groups;

export default asiaAltQueries
